module.exports = __webpack_public_path__ + "static/media/a6.b59f3b48.png";